module.exports = __webpack_public_path__ + "static/media/One_Hundred_bp_DNA_Ladder_M.9b4a82fd.svg";